module.exports = __webpack_public_path__ + "static/media/help-active.9fc2197b.svg";